<ng-container *ngIf="vm$ | async as vm">

  <app-sidebar-card (click)="toggle(expander)">
    <div class="is-flex gap-8 is-align-center">
      <app-sidebar-card-icon name="flash"></app-sidebar-card-icon>
      <app-sidebar-card-label>{{ 'legrand-app.__LEG_COM_CONSUMPTION' | LANG }}</app-sidebar-card-label>
    </div>
    <div class="sidebar-card-right is-flex is-align-center">
      <app-radio-button-group  class="conso-large-screen inline" [selectedIndex]="vm.selectedTabIndex" size="small">
        <ng-container *ngFor="let tab of (tabs[vm.card.graphType] ?? tabs[GraphType.ELEC]); let i = index">
          <app-radio-button-item (click)="selectUnit($event, tab.value, vm.card.graphType)" [selected]="vm.selectedTabIndex === i">
            <app-radio-button-label unit [measureType]="tab.measureType"></app-radio-button-label>
          </app-radio-button-item>
        </ng-container>
      </app-radio-button-group>

      <app-sidebar-card-expand [id]="vm.home.id + '_elec'" #expander class="is-align-end"></app-sidebar-card-expand>
    </div>

  </app-sidebar-card>

  <app-sidebar-card class="conso-small-screen">
    <app-radio-button-group  class="inline" [selectedIndex]="vm.selectedTabIndex" size="small">
      <ng-container *ngFor="let tab of (tabs[vm.card.graphType] ?? tabs[GraphType.ELEC]); let i = index">
        <app-radio-button-item (click)="selectUnit($event, tab.value, vm.card.graphType)" [selected]="vm.selectedTabIndex === i">
          <app-radio-button-label unit [measureType]="tab.measureType"></app-radio-button-label>
        </app-radio-button-item>
      </ng-container>
    </app-radio-button-group>
  </app-sidebar-card>

  <div [@expand]="expander.open ? 'open' : 'close'">
    <app-home-elec-card [selected]="hasElec(vm.card)"></app-home-elec-card>
    <ng-container *ngIf="hasNLE$ | async">
      <app-home-water-card [selected]="hasWater(vm.card)"></app-home-water-card>
      <app-home-gas-card [selected]="hasGas(vm.card)"></app-home-gas-card>
    </ng-container>
  </div>

</ng-container>
